import { Http } from "../Http";
import { AxiosPromise } from "axios";
import { getUserAccessToken } from "../selectors/Accounts";

export default class ReleaseNotificationService {
	public static releaseNotificationGetSetting(input: any) {
		return Http.axios()
			.post("/api/ReleaseNotification/GetReleaseNotificationSettings", input ?? {}, {
				headers: { Authorization: getUserAccessToken() },
			})
			.then((res: any) => {
				return res;
			})
			.catch((e: { response: any }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static releaseNotificationUpdateSetting(input: any) {
		return Http.axios()
			.post("/api/ReleaseNotification/UpdateReleaseNotificationSettings", input, {
				headers: { Authorization: getUserAccessToken() },
			})
			.then((res: any) => {
				return res;
			})
			.catch((e: any) => {
				return e.response;
			}) as AxiosPromise<any>;
	}
}
